import * as S from './styles';
import { useEffect } from 'react';

interface IRadioProps {
  label?: string;
  name: string;
  value: string; // O valor de cada radio
  disabled?: boolean;
  isInvalid?: boolean;
  defaultValue?: string; // Para radio, o default é baseado em value
  errors?: any;
  register: any;
  watch?: any;
  setValue?: any;
}

export function RadioHookLeft({
                                label,
                                name,
                                value,
                                disabled,
                                defaultValue,
                                register,
                                errors,
                                watch,
                                setValue,
                              }: IRadioProps) {
  const { ref, ...inputProps } = register(name);

  useEffect(() => {
    if (watch) {
      watch(name);
    }
  }, [watch, name]);

  const errorToDisplay = errors
    ? Object?.keys(errors).find((key) => key === name)
    : null;

  return (
    <S.Input errorToDisplay={!!errorToDisplay}>
      <div>
        <label className="mx-1">
          <input
            {...inputProps}
            ref={ref}
            className="mt-1"
            type="radio" // Alterado de checkbox para radio
            value={value} // Valor específico para cada radio
            disabled={disabled}
            defaultChecked={defaultValue === value} // Checa se o defaultValue corresponde ao value atual
          />
          <span>{label}</span>
        </label>
        {errorToDisplay && <S.Error>{errors[name]?.message}</S.Error>}
      </div>
    </S.Input>
  );
}
